// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"72":"component---src-pages-[slug]-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"72":"4d174f76118bef9b56b8","678":"4ccdaeeb6f062d11bd6e"}[chunkId] + ".js";
};